export default{crossline:{crossline:{path:{updating:a=>{let b=a.attr.path;return[{initialAttr:{path:a.el.attr('path')},finalAttr:{path:b}}]}}}}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-features/src/crossline/crossline.animation.js
// module id = null
// module chunks = 